import { SELECT_OPTION_ITEM_DATA } from '../../common/select';
import { CITY_ITEM_DATA_RAW_INTER, CITY_LIST_RAW_INTER } from './constant';

export const convertCity = (
  arr: CITY_LIST_RAW_INTER
): SELECT_OPTION_ITEM_DATA[] => {
  if (!Array.isArray(arr)) return [];

  return arr.map((item: CITY_ITEM_DATA_RAW_INTER) => {
    const parts: string[] = [];

    let label = "";

    switch (item.category) {
      case "O": {
        // область
        if (item.adm1) parts.push(`${item.adm1} обл.`);
        label = parts.join(", ");
        break;
      }

      case "K": {
        // місто зі спец. статусом (Київ и т.д.)
        if (item.adm1) parts.push((item.adm1));
        label = parts.join(", ");
        break;
      }

      case "M": {
        // місто
        if (item.adm4) parts.push((item.adm4));
        if (item.adm3) parts.push(`${item.adm3} громада`);
        if (item.adm2) parts.push(`${item.adm2} район`);
        if (item.adm1) parts.push(`${item.adm1} обл.`);
        label = parts.join(", ");
        break;
      }

      case "C": {
        // село
        if (item.adm4) parts.push((item.adm4));
        if (item.adm3) parts.push(`${item.adm3} громада`);
        if (item.adm2) parts.push(`${item.adm2} район`);
        if (item.adm1) parts.push(`${item.adm1} обл.`);
        label = parts.join(", ");
        break;
      }

      default: {
        if (item.adm4) parts.push(item.adm4);
        if (item.adm3) parts.push(`${item.adm3} громада`);
        if (item.adm2) parts.push(`${item.adm2} район`);
        if (item.adm1) parts.push(`${item.adm1}`);
        label = parts.join(", ") || "Unknown";
      }
    }

    return {
      value: item.id,
      label,
    };
  });
};
